import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'
import { WarningIcon } from '@ui/icons/Warning.icon'

import { AccountType, isAccountTypeCorporate } from '@model/AccountType'

import { Box } from '@shared/components/Box'

interface SignupWarningMessagesProps {
  leadTypeId?: AccountType
}

export const SignupWarningMessages: React.FC<SignupWarningMessagesProps> = (props) => {
  const { leadTypeId } = props
  const { t } = useTranslation()

  return (
    <>
      <Box flex gap='x16' mt='x4'>
        <WarningIcon size={16} color='text-warning-high-em' />
        <Body2 color='text-low-em'>
          {t('Sign up.Please complete the following form using Latin letters only')}
        </Body2>
      </Box>
      {leadTypeId && isAccountTypeCorporate(leadTypeId) && (
        <Box flex gap='x16' mt='x4'>
          <WarningIcon size={16} color='text-warning-high-em' />
          <Body2 color='text-low-em'>
            {t(
              'Sign up.The corporate account needs to be completed with details of the corporate entity'
            )}
          </Body2>
        </Box>
      )}
    </>
  )
}
